import checkCollection from "./check-collection.js";
import checkSingleCollectionDocumentCount from "./check-single-collection-document-count.js";

export default {
	checkCollection,
	checkSingleCollectionDocumentCount,
};
